export default (function (target, source, name) {
  var method = source[name];

  if (typeof method !== 'function') {
    throw new Error("Attempt to rebind ".concat(name, " which isn't a function on the source object"));
  }

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var value = method.apply(source, args);
    return value === source ? target : value;
  };
});